import gtm from '@/utils/gtm';
import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import './index.scss';

export interface EfNavPageItemProps {
    /**
     * 点击对应的ID
     */
    href: string;
    /**
     * 标题
     */
    title: string;
}
interface EfNavPageProps {
    /**
     * 样式名
     */
    className?: string;
    /***
     * 背景色
     */
    bgColor?: string;
    /***
     * 文案未被选中时的颜色
     */
    textColor?: string;
    /***
     * 文案被选中时的颜色
     */
    textActiveColor?: string;
    /**
     * 文案被选中时的背景颜色
     */
    textActiveBgColor?: string;
    /**
     * 列表
     */
    items: EfNavPageItemProps[];
    /**
     * 默认选中第几个
     */
    initIndex?: number;
    /**
     * 是否处在编辑页面中
     */
    isEditStatus?: boolean;
}
const defaultItem: EfNavPageItemProps = {
    href: '',
    title: '',
};

/**
 * 维护:谢保林
 *
 * 锚点导航
 */
const EfNavPage: React.FC<EfNavPageProps> = ({
    className,
    items = [],
    bgColor = '',
    textColor = '',
    textActiveColor = '',
    textActiveBgColor = '',
    initIndex = 0,
    isEditStatus = false,
}) => {
    if (!items || !items.length) {
        return null;
    }
    const prefixCls = `ef-nav-page`;
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
    });
    const tabsContainerRef: any = useRef<HTMLDivElement>();
    const activeItemRef = useRef<EfNavPageItemProps>(items[initIndex] || defaultItem);

    const [activeItem, setActiveItem] = useState<EfNavPageItemProps>(items[initIndex] || defaultItem);
    // 点击切换
    const toggleItemHandle = (item: EfNavPageItemProps, index: number) => {
        setTimeout(() => {
            setActiveItem({
                href: item.href,
                title: '',
            });
            activeItemRef.current = {
                href: item.href,
                title: '',
            };
            setRenderKeyA(Math.random());
        }, 150);
        setTimeout(() => {
            tabsContainerRef.current.scrollTo({
                left: 100 * index,
                behavior: 'smooth',
            });
        }, 200);
        gtm.push({
            event: 'uaEvent',
            event_name: 'tab_click',
            button_name: item.title,
            list_name: 'none',
        });
    };
    const compStyle: any = {
        '--nav-bgColor': bgColor,
        '--nav-textColor': textColor,
        '--nav-textActiveColor': textActiveColor,
        '--nav-textActiveBgColor': textActiveBgColor,
    };
    const [compStyleA, setCompStyleA] = useState(compStyle);
    const [renderKeyA, setRenderKeyA] = useState(1);
    // 悬浮多少px
    useEffect(() => {
        const setStickyH = () => {
            const domHeader = document.querySelector('.ecoflow-frame-header');
            // 是否处于编辑状态
            if (isEditStatus) {
                return setCompStyleA(compStyle);
            }
            if (!domHeader) {
                return;
            }
            const styleA = window.getComputedStyle(domHeader);
            const positionA = styleA.position;
            if (positionA !== 'sticky') {
                return;
            }
            const heightA = styleA.height;
            const compStyleB = JSON.parse(JSON.stringify(compStyle));
            setCompStyleA({
                ...compStyleB,
                '--nav-top': heightA,
            });
        };
        setStickyH();
    }, [bgColor, textColor, textActiveColor, textActiveBgColor]);

    useEffect(() => {
        const offsetH = 200; //距离顶部200px时触发
        const bottomOffset = window.innerHeight - offsetH; //元素
        const observer = new IntersectionObserver(
            (elems: any) => {
                for (let i = 0; i < elems.length; i++) {
                    const elem = elems[i];
                    const id = `#${elem.target.id}`;
                    const topNum = elem.boundingClientRect.top;
                    //console.log('id', id, topNum, offsetH, elem.isIntersecting);
                    if (elem.isIntersecting && topNum > 0 && topNum <= offsetH && activeItemRef.current.href !== id) {
                        setActiveItem({
                            href: id,
                            title: '',
                        });
                        activeItemRef.current = {
                            href: id,
                            title: '',
                        };
                    } else {
                    }
                }
            },
            {
                rootMargin: `0px 0px -${bottomOffset}px 0px`,
                threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1], //相对于元素自身(自身进入0%,自身进入100%)
            },
        );

        for (let i = 0; i < items.length; i++) {
            try {
                const item = items[i];
                const itemID = `${item.href}`.slice(1);
                const elem = document.querySelector(`.temp-${itemID}`);
                if (elem) {
                    observer.observe(elem);
                }
            } catch (error) {}
        }
    }, []);

    useEffect(() => {
        const initA = () => {
            if (isEditStatus) {
                return;
            }

            const itemA = items[initIndex];
            if (!itemA) {
                return;
            }
            if (initIndex === 0) {
                return;
            }
            setTimeout(() => {
                try {
                    document.querySelector(`a[href='${itemA.href}']`)?.click();
                } catch (error) {}
            }, 800);
        };
        initA();
    }, [initIndex]);

    return (
        <div className={classes} style={compStyleA}>
            <div className={`${prefixCls}-in`} ref={tabsContainerRef} key={renderKeyA}>
                {items?.map((item: EfNavPageItemProps, index: number) => {
                    const itemHref = item.href || '';
                    const hasID = itemHref.length > 1;
                    const target = itemHref.includes('http') ? '_blank' : '_self';
                    return (
                        <a
                            href={item.href}
                            key={`${index}${item.href}`}
                            target={target}
                            className={`${prefixCls}-item${activeItem.href === item.href && hasID ? ` ${prefixCls}-item-active` : ''}`}
                            onClick={() => {
                                toggleItemHandle(item, index);
                            }}
                        >
                            <span className={`${prefixCls}-item-text`}>{item.title}</span>
                        </a>
                    );
                })}
            </div>
        </div>
    );
};

export default EfNavPage;
